export default __webpack_public_path__ + "static/media/changePassword.30e64c80.svg";